import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { DefaultTokenContext } from '../../context/DefaultTokenContext';
import useSecureStorage from '../../hooks/useSecureStorage';

import CustomText from '../../styles/CustomText';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText } from '../../store';

import i18next from 'i18next'
import { Check } from 'lucide-react';

interface Asset {
    id: number
    name: string
    symbol: string
    balance: string
    icon: any
    address: string | null
    networkid: string
    chainid: string
    networkname: string
    useswap: boolean
    usertoken: boolean
    hidden: boolean
}


const TokenList: React.FC = () => {
    const { theme } = useContext(ThemeContext)
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const { t } = useTranslation();

    const { 
        tokenInfo, 
        userTokenInfo, 
        removeToken } = useContext(DefaultTokenContext)
    const { getBlockChain, setHideToken, getHideToken } = useSecureStorage()
    
    const [defaultAssetsList, setDefaultAssetsList] = useState<Asset[]>([]);
    const [assets, setAssets] = useState<Asset[]>([]);
    const [isConfirmModalVisible, setConfirmModalVisible] = useState(false)
    const [deleteTokenAddress, setDeleteTokenAddress] = useState('');

    // const dismissKeyboard = () => {
    //     Keyboard.dismiss()
    // }

    useEffect(() => {
        const initTitle = async () => {
            const networkName = await getBlockChain();
            const title =  networkName.toUpperCase() + ' ' + t('see_more_screen_message_13')
            dispatch(checkHeaderText({ "link": "TokenList", "title": title }))
        }

        initTitle()
    }, [])

    useEffect(() => {
        const initializeAssets = async () => {
            const selNetwork = await getBlockChain();
            
            const hiddenTokens = await getHideToken(selNetwork.toLowerCase());
            console.log(`TokenList hiddenTokens`, hiddenTokens)

            // 현재 네트워크와 일치하는 토큰만 표시, token.type이 'token'인 데이터만 표시
            const defaultAssets = tokenInfo
            .filter(
                token =>
                token.networkname.toLowerCase() === selNetwork.toLowerCase() &&
                token.type === 'token'
            )
            .map((token, index) => ({
                id: index,
                name: token.name,
                symbol: token.symbol,
                balance: '0.000000',
                icon: token.icon || './img/icon_none.png',
                address: token.contract,
                networkid: token.networkid,
                chainid: token.chainid,
                networkname: token.networkname,
                useswap: token.useswap,
                usertoken: false,
                // hidden 여부를 숨김 목록(hiddenTokens)에서 토큰 이름으로 판단
                hidden: hiddenTokens.some((hiddenToken: any) => hiddenToken.toLowerCase() === token.name.toLowerCase())
            }));
            console.log(`TokenList defaultAssets 1`, defaultAssets)

            const defaultLength = defaultAssets.length || 1;
            // 사용자 지정 토큰 리스트 생성 (userTokenInfo에서 필터링)
            const userAssets = userTokenInfo
            .filter(
                token =>
                token.networkname.toLowerCase() === selNetwork.toLowerCase() &&
                token.type === 'token'
            )
            .map((token, index) => ({
                id: index + defaultLength,
                name: token.name,
                symbol: token.symbol,
                balance: '0.000000',
                icon: token.icon || './img/icon_none.png',
                address: token.contract,
                networkid: token.networkid,
                chainid: token.chainid,
                networkname: token.networkname,
                useswap: token.useswap,
                usertoken: true,
                hidden: hiddenTokens.some((hiddenToken: any) => hiddenToken.toLowerCase() === token.name.toLowerCase())
            }));

            setDefaultAssetsList([
                ...defaultAssets,
                ...userAssets
            ]);

            setAssets([
                ...defaultAssets,
                ...userAssets
            ]);
        };

        initializeAssets();
    }, [tokenInfo, userTokenInfo]);

    const handleSelectToken = async (token: any) => {
        console.log(`TokenList handleSelectToken token`, token);
    
        // 토큰 숨김 설정
        await setHideToken(token.name, token.networkname.toLowerCase());
        console.log(`TokenList handleSelectToken 토큰 숨김 설정 변경`, token);
    
        // 지정한 네트워크의 숨김 토큰 목록을 가져옴 (로컬스토리지에서)
        const hiddenTokens = await getHideToken(token.networkname.toLowerCase());
        
        // 로컬스토리지에 저장된 hiddenTokens가 문자열 배열이므로, 직접 문자열 비교 수행
        const isTokenHidden = hiddenTokens.some((t: any) => t.toLowerCase() === token.name.toLowerCase());
        
        // assets 상태 업데이트: 해당 토큰에 hidden 속성을 업데이트하여 UI에 반영
        setAssets(assets =>
            assets.map(item => {
                if (
                    item.networkname.toLowerCase() === token.networkname.toLowerCase() &&
                    item.name.toLowerCase() === token.name.toLowerCase()
                ) {
                    return { ...item, hidden: isTokenHidden };
                }
                return item;
            })
        );
    };
    


    const handleConfirmDelete = async () => {
        setConfirmModalVisible(false)

        const delTokenContract = deleteTokenAddress

        // 토큰 삭제
        const result = await removeToken(delTokenContract);
        if ('success' === result) {
            // Toast.show({
            //     type: 'success',
            //     text1: i18next.t('list_token_screen_message_01'),
            //     position: 'bottom',
            //     visibilityTime: 800
            // })
            alert(i18next.t('list_token_screen_message_01'));
        }
        else {
            // Toast.show({
            //     type: 'error',
            //     text1: i18next.t('list_token_screen_message_02'),
            //     position: 'bottom',
            //     visibilityTime: 800
            // })
            alert(i18next.t('list_token_screen_message_02'));
        }
    }

    const handleShowInfoToken = async (contract: any) => {

        // 상세정보 표시할 토큰 정보 저장
        // setInfoTokenAddress(contract);
        // setInfoModalVisible(true);
    }

    const renderDeleteModal = () => (
        isConfirmModalVisible && (
            <div style={styles.modalBackground}>
                <div style={{ ...styles.modalContainer, backgroundColor: theme.modal_background_02 }}>
                    <CustomText weight="bold" style={{ ...styles.modalTitle, color: theme.text_17 }}>
                        {t('security_setting_screen_message_09')}
                    </CustomText>
                    <CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
                        {t('security_setting_screen_message_10')}
                    </CustomText>
                    <CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
                        {t('security_setting_screen_message_11')}
                    </CustomText>
                    <CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
                        {t('security_setting_screen_message_12')}
                    </CustomText>
                    <CustomText style={{ ...styles.modalMessage, color: theme.label_strong }}>
                        {t('security_setting_screen_message_13')}
                    </CustomText>

                    <div style={styles.modalButtons}>
                        <button
                            style={styles.cancelButton}
                            onClick={() => setConfirmModalVisible(false)}
                        >
                            <CustomText style={{ ...styles.cancelButtonText, color: theme.label_strong }}>
                                {t('security_setting_screen_message_14')}
                            </CustomText>
                        </button>
                        <button
                            style={styles.confirmButton}
                            onClick={handleConfirmDelete}
                        >
                            <CustomText style={{ ...styles.confirmButtonText, color: theme.text_17 }}>
                                {t('security_setting_screen_message_15')}
                            </CustomText>
                        </button>
                    </div>
                </div>
            </div>
        )
    )

    // 토큰정보 모달
    // const renderInfoModal = () => (
    //     <RNModal isVisible={isInfoModalVisible} onBackdropPress={() => setInfoModalVisible(false)}>
    // 		<View style={styles.infoModalContent}>
    // 			<View style={styles.infoModalHeader}>
    // 				<CustomText weight='medium' style={[styles.modalTitle]}>
    // 					{i18next.t('template_wallet_screen_message_11')}
    // 				</CustomText>
    // 				<TouchableOpacity onPress={() => setInfoModalVisible(false)}>
    // 					<Icon name='close' size={24} color=theme.text_01 />
    // 				</TouchableOpacity>
    // 			</View>

    // 			{/* <CustomButton
    // 				containerStyle={[styles.dateSubmitButton, { backgroundColor: theme.primary_normal }]}
    // 				textStyle={[styles.dateSubmitButtonText]}
    // 				onPress={handleDateSubmit}
    // 				text={i18next.t('template_wallet_screen_message_14')}
    // 				weight='medium'
    // 				withBackground={true}
    // 				backgroundColor={theme.background_08}
    // 			/>*/}
    // 		</View>
    // 	</RNModal>
    // )

    const styles = {
        container: {
            padding: "60px 5px 24px",
        } as React.CSSProperties,
        inner: {
            display: "flex",
            justifyContent: 'space-between',
            width: "100%"
        } as React.CSSProperties,
        text: {
            fontSize: 16,
            marginBottom: 16,
            textAlign: 'center'
        } as React.CSSProperties,
        button: {
            padding: "24px 12px",
            borderRadius: 10,
            width: '100%',
            position: 'absolute',
            bottom: 60,
            marginBottom: 0,
            justifyContent: 'center'
        } as React.CSSProperties,
        transactionItem: {
            display: "flex",
            alignItems: 'center',
            padding: "13px 15px",
            backgroundColor: theme.card_background_04,
            borderRadius: 10,
            marginBottom: 10,
            border: `1px solid ${theme.border_04}`
        } as React.CSSProperties,
        transactionIcon: {
            width: 30,
            height: 30,
            backgroundColor: theme.img_background_01,
            borderRadius: 25,
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 15
        } as React.CSSProperties,
        transactionDetails: {
            flex: 1
        } as React.CSSProperties,
        transactionName: {
            fontSize: 15
        } as React.CSSProperties,
        transactionAmountContainer: {
            display: "flex",
            alignItems: 'center'
        } as React.CSSProperties,
        xIcon: {
            width: 15,
            height: 15
        } as React.CSSProperties,
        modalBackground: {
            display: "flex",
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: theme.background_alternative,
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0
        } as React.CSSProperties,
        modalContainer: {
            width: '90%',
            backgroundColor: 'white',
            borderRadius: 10,
            padding: '20px',
            border: `1px solid ${theme.border_09}`,
            boxSizing: "border-box"
        } as React.CSSProperties,
        modalTitle: {
            fontSize: 18,
            color: theme.text_17,
            textAlign: 'center',
            marginBottom: 10
        } as React.CSSProperties,
        modalMessage: {
            fontSize: 14,
            color: theme.text_02,
            textAlign: 'center'
        } as React.CSSProperties,
        modalButtons: {
            display: "flex",
            width: '100%',
            borderTop: `1px solid ${theme.border_10}`,
            marginTop: 20
        } as React.CSSProperties,
        cancelButton: {
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
            paddingVertical: 10,
            borderRight: `1px solid ${theme.border_10}`,
        } as React.CSSProperties,
        cancelButtonText: {
            color: theme.text_15,
            fontSize: 16
        } as React.CSSProperties,
        confirmButton: {
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
            paddingVertical: 10
        } as React.CSSProperties,
        confirmButtonText: {
            color: theme.text_17,
            fontSize: 16
        } as React.CSSProperties,
        infoModalContent: {
            backgroundColor: 'white',
            padding: 20,
            borderRadius: 20,
            alignItems: 'center'
        } as React.CSSProperties,
        infoModalHeader: {
            display: "flex",
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center',
            marginBottom: 20,
            padding: "0 10px",
        } as React.CSSProperties,
        deleteButton: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
        } as React.CSSProperties,
    }

    return (
        <div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
            <div style={styles.inner}>
                <div style={{ flex: 1, justifyContent: 'flex-start', gap: '5px' }}>
                    {assets.map((item, index) => (
                        <div key={index} 
                            style={{ ...styles.transactionItem, backgroundColor: theme.background_10 }}
                            onClick={() => { handleSelectToken(item) }}
                        >
                            <img
                                src={item.icon}
                                alt={`${item.name} icon`}
                                style={styles.transactionIcon}
                            />
                            <div style={styles.transactionDetails}>
                                <span style={{ ...styles.transactionName, color: theme.label_strong }}>
                                    {item.name.toUpperCase()}
                                </span>
                            </div>
                            <div style={styles.transactionAmountContainer}>
                                {item.hidden === false && 
                                    <Check size={20} color={theme.primary_normal} />
                                }
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* {renderInfoModal()} */}
            {renderDeleteModal()}
        </div>
    )
}

export default TokenList
